import Index from './Index.vue'
import Hotels from './hotels'
import Tours from './tours'
import Fit from './fit'

export default {
  Index,
  Hotels,
  Tours,
  Fit
}